import {extractFormErrorsFromResponse, putAll, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {subjectManagementFormName} from '../../types/subject-management-form-values';
import {adminAction, UpdateManagementAssociationDetailAction} from '../action';

const te = t('common');
const title = te('updateEntry');

function* execute({payload: {associationId}}: UpdateManagementAssociationDetailAction): SagaIterator {
    const formValues = yield* select(formHelpers.formValues(subjectManagementFormName));
    yield* put(formHelpers.startSubmit(subjectManagementFormName));

    const response = yield* call(Api.updateUserProfileAssociationRoleBySubjectManager, {
        approvedTo: formValues.prop('approvedTo').orNull(),
        userProfileAssociationRoleId: formValues
            .prop('userProfileRoleIds').headIn().orCrash('No userProfileRoleIds found'),
    });

    if (response.isSuccess) {
        yield* put(adminAction.getManagementAssociationsTableData(opt({action: 'refresh'}), opt(associationId)));
        yield* put(showSuccess(title, te('updateEntrySuccess'), false, 'updateManagementAssociation'));
        yield* put(adminAction.setManagementSubjectModalVisible(null));
        yield* put(formHelpers.reset(subjectManagementFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(subjectManagementFormName, extractFormErrorsFromResponse(response)));
    }
}
/** Runs the admin saga that updates the selected association-management binding. */
export function* updateManagementAssociationDetailSaga(): SagaIterator {
    yield takeLatestF('admin/UPDATE_MANAGEMENT_ASSOCIATION_DETAIL', execute);
}
